export default "__VITE_ASSET__CNp09Oi6__"